import { cn } from "@/lib/utils";

export function RadioOption({
  label,
  description,
  selected,
  disabled = false,
  onSelect,
}: {
  label: string;
  description: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      disabled={disabled}
      onClick={onSelect}
      className={cn(
        "flex items-center gap-2 rounded-md px-2 py-1 text-xs transition-colors",
        disabled ? "opacity-40" : "cursor-pointer text-foreground",
      )}
    >
      <div
        className={cn(
          "flex size-3.5 shrink-0 items-center justify-center rounded-full border",
          selected ? "border-[#FFAF53] bg-[#FFAF53]" : "border-contrast/20",
        )}
      >
        {selected && <div className="size-1.5 rounded-full bg-black" />}
      </div>
      {label}
      <span className="text-[11px] text-muted-foreground">{description}</span>
    </button>
  );
}
